import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';

export default class Modalusercommentbacktbn extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",
   id_comment:"",
   id_bn:"",
   filewordcomment_back:null,
   filepdfcomment_back:null,


   id_articlepsf:'',
   id_empbn:'',
   nameuserbn:'',
   send_uploadewordbn:null,
   send_uploadewordbn2:null,
   send_uploadewordbn3:null,
   send_uploadewordbn4:null,
   send_uploadepdfbn:null,
   send_uploadepdfbn2:null,
   send_uploadepdfbn3:null,
   send_uploadepdfbn4:null,
   idarticlebn:'',


}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChangew2 = this.handleChangew2.bind(this);
this.handleChangew3 = this.handleChangew3.bind(this);
this.handleChangew4 = this.handleChangew4.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleChangep2 = this.handleChangep2.bind(this);
this.handleChangep3 = this.handleChangep3.bind(this);
this.handleChangep4 = this.handleChangep4.bind(this);

this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({comment_bn: event.target.value});  }


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_articlepsf:this.props.id_articlepsf,
                       id_empbn:this.props.id_empbn,
                       nameuserbn:this.props.nameuserbn,
                       idarticlebn:this.props.idarticlebn,
                     
        })
    //   this.setState({ id_bn:this.props.expert_id})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }




  handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_uploadewordbn: event.target.files[0]});  }
  handleChangew2(event) {    this.setState({send_uploadewordbn2: event.target.files[0]});  }
  handleChangew3(event) {    this.setState({send_uploadewordbn3: event.target.files[0]});  }
  handleChangew4(event) {    this.setState({send_uploadewordbn4: event.target.files[0]});  }

  handleChange3(event) {    this.setState({send_uploadepdfbn: event.target.files[0]});  }
  handleChangep2(event) {    this.setState({send_uploadepdfbn2: event.target.files[0]});  }
  handleChangep3(event) {    this.setState({send_uploadepdfbn3: event.target.files[0]});  }
  handleChangep4(event) {    this.setState({send_uploadepdfbn4: event.target.files[0]});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_articlepsf", this.state.id_articlepsf);
      datafrm.append("id_empbn", this.state.id_empbn);
      datafrm.append("nameuserbn", this.state.nameuserbn);
      datafrm.append("send_uploadewordbn", this.state.send_uploadewordbn);
      datafrm.append("send_uploadewordbn2", this.state.send_uploadewordbn2);
      datafrm.append("send_uploadewordbn3", this.state.send_uploadewordbn3);
      datafrm.append("send_uploadewordbn4", this.state.send_uploadewordbn4);
      datafrm.append("send_uploadepdfbn", this.state.send_uploadepdfbn);
      datafrm.append("send_uploadepdfbn2", this.state.send_uploadepdfbn2);
      datafrm.append("send_uploadepdfbn3", this.state.send_uploadepdfbn3);
      datafrm.append("send_uploadepdfbn4", this.state.send_uploadepdfbn4);
      datafrm.append("dateaddbn", dates);
      datafrm.append("statusbn", '1');
      datafrm.append("idarticlebn", this.state.idarticlebn);
      
      
      api.post("registercon/InsertArticleseditpsf",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data = '200') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })




}, 1000);

  //this.props.updateat();
 // this.toggle()
  //this.getExpert()

  }

  

    render() {
      //  console.log(this.state.filewordcomment_back)

        return (
            <MDBContainer className='text-left'>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>อัพโหลดไฟล์ปรับแก้</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="fluid">
              <MDBModalHeader toggle={this.toggle}>
              อัพโหลดไฟล์ปรับแก้
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <div>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}


              {/* <p>อัพโหลดไฟล์แบบประเมิน .pdf</p> */}
                {/* <MDBInput   group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}

                   <MDBRow  className='mt-1'>
                      <MDBCol md="3">
                            <div className="mb-2">
                             <label><strong className='blue-text'>อัพโหลดไฟล์ผลงาน PSF01 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        required />
                            </div>
                      </MDBCol>
                      <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='blue-text'>อัพโหลดไฟล์ผลงาน PSF02 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangew2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        required />
                            </div>
                      </MDBCol>
                      <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='blue-text'>อัพโหลดไฟล์ผลงาน PSF03 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangew3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        required />
                            </div>
                      </MDBCol>
                      <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='blue-text'>อัพโหลดไฟล์ผลงาน PSF04 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangew4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        required />
                            </div>
                      </MDBCol>
                    </MDBRow>               
                            
                          
                           
                            

 <MDBRow  className='mt-1'>
                  
                    <MDBCol md="3">
                          <div className="mb-2">
                            <label><strong className='red-text'>อัพโหลดไฟล์ผลงาน PSF01 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                          </div>
                    </MDBCol>
                    <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='red-text'>อัพโหลดไฟล์ผลงาน PSF02 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangep2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div>
                    </MDBCol>
                    <MDBCol md="3">
                          <div className="mb-2">
                            <label><strong className='red-text'>อัพโหลดไฟล์ผลงาน PSF03 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangep3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div>
                    </MDBCol>
                    <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='red-text'>อัพโหลดไฟล์ผลงาน PSF04 ที่ปรับแก้ไขแล้ว <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangep4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div>
                    </MDBCol>
                    </MDBRow> 
           
            
              </div>
              <div>
                <Alert
      title="Warning Text"
      description="หลังอัพโหลดไฟล์ปรับแก้ ขอให้อาจารย์จัดส่งเอกสาร KPRU PSF01-04 จำนวน 3 ฉบับ  และลงลายเซ็นจริงทั้ง 3 ฉบับ กรุณาใส่ซองปะหน้าให้เรียบร้อย สามารถดาวน์โหลดแบบฟอร์มได้ที่ https://reg.kpru.ac.th/th/data/psf/sent_psf1.pdf สถานที่จัดส่ง สำนักส่งเสริมวิชาการและงานทะเบียน ชั้น 2 อาคาร 14
มหาวิทยาลัยราชภัฏกำแพงเพชร  "
      type="warning"
    />
              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
                {this.state.send_uploadewordbn == null || this.state.send_uploadepdfbn == null ? <><MDBBtn color="primary" disabled >บันทึก</MDBBtn> </> :<>  <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> }
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                
              
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }//////////////////////////////////////////////////////////////////////////////////                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    ////////////////////////////////////////////////////////////////////////////////////
}


